module.exports = __webpack_public_path__ + "img/Croatia.99bc4498.svg";